import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "@mdi/react";
import { mdiCalendarRemoveOutline } from "@mdi/js";
import { setCurrentStep, resetBookingOutcome } from "../slice";
import BookingHeader from "./BookingHeader";

const BookingFailure = () => {
  const dispatch = useDispatch();
  const { companyInfo } = useSelector((state) => state.publicClientBooking);

  const handleTryAgain = () => {
    dispatch(resetBookingOutcome());
    dispatch(setCurrentStep(2));
  };

  return (
    <div className="public-client-booking-container">
      <BookingHeader
        companyName={companyInfo?.name}
        companyLogo={companyInfo?.logo}
      />
      <main className="public-client-booking-outcome-main">
        <div className="public-client-booking-failure-icon-wrapper">
          <Icon path={mdiCalendarRemoveOutline} size={1.5} color="#fff" />
        </div>

        <h1 className="public-client-booking-outcome-title">Booking failed</h1>
        <p className="public-client-booking-outcome-subtitle public-client-booking-outcome-subtitle--spaced">
          We couldn&apos;t complete your booking at this time.
          <br />
          Please try again or choose a different time.
        </p>

        <button
          type="button"
          className="btn btn-primary public-client-booking-outcome-btn"
          onClick={handleTryAgain}
        >
          Try Again
        </button>
      </main>
    </div>
  );
};

export default BookingFailure;
